<script setup lang="ts">
interface Prors {
  data?: {
    icon?: string
    img?: string
  }
}
withDefaults(defineProps<Prors>(), {
  data: {
    icon: () => 'i-local:wallets--metamask',
    img: () => 'https://docs.walletconnect.com/img/walletconnect-logo-black.svg#light-mode-only',
  },
})
</script>

<template>
  <span class="w-60px h-60px flex justify-center items-center">
    <!-- <svg class="icon w-full h-full" aria-hidden="true" v-if="data.icon">
      <use :xlink:href="`#${data.icon}`"></use>
    </svg> -->
    <!-- <i v-if="data.icon" class="icon text-[50px] overflow-hidden rounded-[10px]" :class="`i-local:wallets--tronlink`" /> -->
    <i v-if="data.icon" class="icon text-[50px] overflow-hidden rounded-[10px]" :class="data.icon" />
    <img v-else class="w-49px h-49px" :src="data.img">
  </span>
</template>
